import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { IssuedStatusEnum } from '@/api/types';
import {
  getBookingSearchForm,
  setBookingSearchForm,
  removeBookingSearchForm,
  getBookingIssueTicketReceipt,
  setBookingIssueTicketReceipt,
  removeBookingIssueTicketReceipt,
} from '@/utils/localstorage';

export class BookingSearchForm {
  public detailedSearch = false;
  public participantName = '';
  public bookingIdPrefix = '';
  public supplierId = '';
  public activityName = '';
  public planName = '';
  public purchaseDateRange: string[] = [];
  public participationDateRange: string[] = [];
  public statuses: IssuedStatusEnum[] = [];
}

export class IssueTicketReceipt {
  public supplierName = 'Dummy Supplier';
  public supplierId = 'Dummy SupplierId';
  public accountName = 'Dummy Account Name';
  public bookingId = 'OTAID-YYYYMMDD-XXXXX';
  public activityName = 'Dummy Activity Name';
  public planName = 'Dummy Plan Name';
  public participantName = 'Dummy Participant Name';
  public reprint = false;
  public tickets: {
    ticketName: string;
    ticketCount: number;
  }[] = [
    {
      ticketName: 'Dummy Ticket Name1',
      ticketCount: 1,
    },
    {
      ticketName: 'Dummy Ticket Name2',
      ticketCount: 1,
    },
  ];
  public issuedTime = 'YYYY-MM-DD hh:mm:ss';
  public autoPrint = false;
}

export interface IBookingState {
  searchForm: BookingSearchForm;
}

@Module({
  dynamic: true,
  name: 'booking',
  store,
})
class BookingStore extends VuexModule implements IBookingState {
  public searchForm = new BookingSearchForm();
  public issueTicketReceipt = new IssueTicketReceipt();

  @Mutation
  private SET_BOOKING_SEARCH_FORM(searchForm: BookingSearchForm) {
    this.searchForm = searchForm;
  }

  @Mutation
  private SET_BOOKING_ISSUE_TICKET_RECEIPT(
    issueTicketReceipt: IssueTicketReceipt
  ) {
    this.issueTicketReceipt = issueTicketReceipt;
  }

  @Action
  public LoadBookingSearchForm() {
    let searchForm = JSON.parse(
      getBookingSearchForm() as string
    ) as BookingSearchForm;
    searchForm = searchForm || new BookingSearchForm();
    this.SET_BOOKING_SEARCH_FORM(searchForm);
  }

  @Action
  public SaveBookingSearchForm(searchForm: BookingSearchForm) {
    setBookingSearchForm(JSON.stringify(searchForm));
    this.SET_BOOKING_SEARCH_FORM(searchForm);
  }

  @Action
  public ClearBookingSearchForm() {
    removeBookingSearchForm();
    this.SET_BOOKING_SEARCH_FORM(new BookingSearchForm());
  }

  @Action
  public LoadBookingIssueTicketReceipt() {
    let receipt = JSON.parse(
      getBookingIssueTicketReceipt() as string
    ) as IssueTicketReceipt;
    receipt = receipt || new IssueTicketReceipt();
    this.SET_BOOKING_ISSUE_TICKET_RECEIPT(receipt);
  }

  @Action
  public SaveBookingIssueTicketReceipt(receipt: IssueTicketReceipt) {
    setBookingIssueTicketReceipt(JSON.stringify(receipt));
    this.SET_BOOKING_ISSUE_TICKET_RECEIPT(receipt);
  }

  @Action
  public ClearBookingIssueTicketReceipt() {
    removeBookingIssueTicketReceipt();
    this.SET_BOOKING_ISSUE_TICKET_RECEIPT(new IssueTicketReceipt());
  }

  @Action ClearBookingStore() {
    this.ClearBookingSearchForm();
    this.ClearBookingIssueTicketReceipt();
  }
}

export const BookingModule = getModule(BookingStore);
